import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PendingItem, PendingItemCount} from '../DataModels/inventory-count-pending.model';
import {AppConfigService} from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class InventoryCountPendingService {
  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
  }

  private get baseUrl(): string {
    const root = this.appConfigService?.apiBaseUrl || '/api/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    return `${normalizedRoot}inventory-count`;
  }

  getPendingItemCount(countId: string): Observable<PendingItemCount> {
    return this.http.get<PendingItemCount>(`${this.baseUrl}/${countId}/pending-items/count`);
  }

  getPendingItems(countId: string, status: string = 'unresolved'): Observable<PendingItem[]> {
    const params = new HttpParams().set('status', status);
    return this.http.get<PendingItem[]>(`${this.baseUrl}/${countId}/pending-items`, {params});
  }

  matchPendingItem(countId: string, pendingId: string, itemId: string): Observable<any> {
    return this.http.put(`${this.baseUrl}/${countId}/pending-items/${pendingId}/match`, {itemId});
  }

  dismissPendingItem(countId: string, pendingId: string, notes?: string): Observable<any> {
    return this.http.put(`${this.baseUrl}/${countId}/pending-items/${pendingId}/dismiss`, {notes});
  }

  finalizeCount(countId: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/${countId}/finalize`, {});
  }
}
